import Vue from 'vue';
import iView, { locale, Icon } from 'iview';

import lang from 'iview/dist/locale/ar-EG';
import 'iview/dist/styles/iview.css';

Vue.use(iView);

locale(lang);

Vue.component('Icon', Icon);
